import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { responseLogWithNotification } from '../../../utils/utils';
import ParkingMeterPopup from '../../ParkingMeter/components/ParkingMeterPopup';
import { optionClassFormatter } from '../../../utils/formatters';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import { loadHostDetail } from '../../ParkingMeter/actions';
import { sortByStatus } from '../../ParkingMeter/parking-meter-utils';
import { cMetricKeys } from '../constants';
import CamerasPopup from './CamerasPopup';

export default function CamerasMatrix(props) {
  const {
    camerasStatusesList = [],
    hostDetail,
  } = props;
  const [showParkingMeter, setShowParkingMeter] = useState(false);
  const dispatch = useDispatch();
  const [scroll, setScroll] = useState(null);
  useEffect(() => {
    const a = new window.IScroll('#scroll-wrapper', {
      scrollbars: true,
      mouseWheel: true,
      interactiveScrollbars: true,
      preventDefault: false,
    });
    setScroll(a);
  }, []);
  useEffect(() => {
    if (scroll) {
      scroll.refresh();
    }
  }, [camerasStatusesList]);
  const onMarkerClick = item => {
    dispatch(loadHostDetail({ id: item.id, metricKeys: cMetricKeys })).then(() => {
      setShowParkingMeter(true);
    }).catch(responseLogWithNotification);
  };
  const list = camerasStatusesList.sort(sortByStatus);
  return (
    <div className="scroll-wrapper" id="scroll-wrapper">
      <div className="scroll matrix-scroll">
        <div className="frame matrix-frame position-relative g-0">
          <div className="matrix-wrapper camera-matrix">
            {list.map((item, key) => (
              <div key={key} onClick={() => { onMarkerClick(item); }} className={classNames('matrix-element', optionClassFormatter(item.status))}>
                <Tooltip content={item.name} />
              </div>
            ))}
          </div>
          {showParkingMeter ? <CamerasPopup item={hostDetail} handleClose={() => setShowParkingMeter(false)} /> : null}
        </div>
      </div>
    </div>
  );
}
